"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLoggedIn = void 0;
const cookieManager_1 = require("../utils/cookieManager");
const refreshToken_1 = require("../methods/refreshToken");
function isLoggedIn() {
    return __awaiter(this, void 0, void 0, function* () {
        const id_token = cookieManager_1.getCookie('id_token');
        if (!id_token)
            return false;
        const access_token = cookieManager_1.getCookie('access_token');
        if (access_token)
            return true;
        const tokens = yield refreshToken_1.refreshToken();
        return !!tokens;
    });
}
exports.isLoggedIn = isLoggedIn;
